












































import Vue from "vue";

export default Vue.extend({
  name: "Softway",

  data: () => ({
    items: [
      {
        description: "experiences.softway.disrupthor",
        details: [
          "details.angular",
          "details.nestjs",
          "details.typescript",
          "details.openshift",
          "details.docker",
          "details.gitlab",
          "details.cicd",
          "details.ds"
        ]
      },
      {
        description: "experiences.softway.planningpoker",
        details: [
          "details.vuejs",
          "details.nestjs",
          "details.websockets",
          "details.typescript",
          "details.openshift",
          "details.docker",
          "details.gitlab",
          "details.cicd",
          "details.ds"
        ]
      },
      {
        description: "experiences.softway.dexther",
        details: [
          "details.java",
          "details.spring",
          "details.maven",
          "details.hibernate",
          "details.quarkus",
          "details.openshift",
          "details.scrummaster",
          "details.english",
          "details.scrum",
          "details.docker",
          "details.gitlab",
          "details.cicd"
        ]
      },
      {
        description: "experiences.softway.pmm",
        details: [
          "details.vuejs",
          "details.mongodb",
          "details.typescript",
          "details.nestjs",
          "details.openshift",
          "details.ux",
          "details.ds",
          "details.scrummaster",
          "details.english",
          "details.scrum",
          "details.docker",
          "details.gitlab",
          "details.cicd"
        ]
      },
      {
        description: "experiences.softway.injectable",
        details: [
          "details.java",
          "details.jsp",
          "details.spring",
          "details.hibernate",
          "details.oracle",
          "details.angularjs",
          "details.maven",
          "details.rational",
          "details.scrum"
        ]
      },
      {
        description: "experiences.softway.offline",
        details: [
          "details.couchbase",
          "details.couchbasemobile",
          "details.angular",
          "details.java",
          "details.openshift",
          "details.springboot",
          "details.scrum",
          "details.git",
          "details.docker",
          "details.gitlab",
          "details.cicd"
        ]
      }
    ]
  })
});
